import noop from 'lodash/noop';
import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

type LayoutConfig = {
  headerButtons?: ReactNode;
  showCloseButton?: boolean;
  onClose?: () => void;
  showBackButton?: boolean;
  onBack?: () => void;
};

const FullScreenLayoutContext = createContext<{
  config: LayoutConfig;
  setConfig: (config: LayoutConfig) => void;
}>({
  config: {},
  setConfig: noop,
});

export function FullScreenLayoutProvider({
  children,
}: {
  readonly children: ReactNode;
}) {
  const [config, setConfig] = useState<LayoutConfig>({});

  const contextValue = useMemo(
    () => ({ config, setConfig }),
    [config, setConfig],
  );

  return (
    <FullScreenLayoutContext.Provider value={contextValue}>
      {children}
    </FullScreenLayoutContext.Provider>
  );
}

export const useFullScreenLayoutConfig = () =>
  useContext(FullScreenLayoutContext);
